export const SAVEDATA = 'SAVEDATA'
export const SAVE_USER_INFORMATION = 'SAVE_USER_INFORMATION'

export const SHOWANIMATIONFORM = 'SHOWANIMATIONFORM'
export const HIDEANIMATIONFORM = 'HIDEANIMATIONFORM'
export const BACKPREVFORM = 'BACKPREVFORM'

export const SHOWFORMS = 'SHOWFORMS'
export const FETCHDERICTORY = 'FETCHDERICTORY'
export const FETCHSCENARIO = 'FETCHSCENARIO'
export const ERROR = 'ERROR'
export const HASREZULT = 'HASREZULT'

export const SHOWFORMREZULT = 'SHOWFORMREZULT'

export const STARTLOADING = "STARTLOADING"
export const STOPLOADING = "STOPLOADING"